import { Button, Icon, Modal } from "semantic-ui-react";

import DataJobErrorsTableV3 from "routes/data_tab/components/data_job_errors_table/DataJobErrorsTableV3";

const ValidationReport = ({ dataJobId }) => {
  return (
    <Modal
      closeIcon
      size="fullscreen"
      trigger={
        <Button secondary compact size="tiny" style={{ margin: "0.3em 0 0" }}>
          <Icon name="eye" />
          View Errors
        </Button>
      }
    >
      <Modal.Header>Import Validation Report</Modal.Header>
      <Modal.Content>
        {/* The fullscreen modal's header and padding take about 146px. */}
        <div className="tw:flex tw:h-[calc(100vh-146px)] tw:w-full tw:flex-col tw:overflow-y-auto tw:p-6">
          <DataJobErrorsTableV3 dataJobId={dataJobId} />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ValidationReport;
